import {observer} from 'mobx-react';
import {Panel, FormLayout, Select2, Input, PanelTooltip} from 'shared/components';
import {t} from 'shared/core';
import {FormattedMessage} from 'react-intl';
import {timeZoneOptions} from 'shared/tools/timeZones';
import AvailabilityWindowsTable from './components/AvailabilityWindowsTable';
import _ from 'lodash';

const Availability = observer(({uiState}) => {
  const {interviewSchedule, errors} = uiState;
  const {
    relativeEndDateUnit, relativeEndDateValue,
    minimumNoticeValue, minimumNoticeUnit,
    eventBuffer, timezone
  } = interviewSchedule;

  return (
    <div>
      <Panel.Header title={t('recruiting.interview_schedules.edit.Availability')}/>
      <FormLayout>
        <div className='flex items-center'>
          <span className='tuatara mr2'>
            <FormattedMessage id='recruiting.interview_schedules.edit.Allow booking up to'/>
          </span>
          <Input
            value={relativeEndDateValue}
            onChange={e => interviewSchedule.merge({relativeEndDateValue: e.target.value})}
            connectedRight={
              <Select2
                value={relativeEndDateUnit}
                onChange={e => interviewSchedule.merge({relativeEndDateUnit: e.target.value})}
              >
                <option key='days' value='days'>{t('recruiting.interview_schedules.edit.units.days')}</option>
                <option key='weeks' value='weeks'>{t('recruiting.interview_schedules.edit.units.weeks')}</option>
              </Select2>
            }
            errorMessage={errors.relativeEndDateValue}
          />
          <span className='tuatara ml2'>
            <FormattedMessage id='recruiting.interview_schedules.edit.from invite being sent'/>
          </span>
          <PanelTooltip text='recruiting.interview_schedules.edit.tooltips.relative_end_date'/>
        </div>
        <FormLayout.Group>
          <Input
            label='recruiting.interview_schedules.edit.Minimum Notice'
            tooltip={{paragraphs: [t('recruiting.interview_schedules.edit.tooltips.minimum_notice')]}}
            value={minimumNoticeValue}
            onChange={e => interviewSchedule.merge({minimumNoticeValue: e.target.value})}
            connectedRight={
              <Select2
                value={minimumNoticeUnit}
                onChange={e => interviewSchedule.merge({minimumNoticeUnit: e.target.value})}
              >
                <option key='hours' value='hours'>{t('recruiting.interview_schedules.edit.units.hours')}</option>
                <option key='days' value='days'>{t('recruiting.interview_schedules.edit.units.days')}</option>
              </Select2>
            }
            errorMessage={errors.minimumNoticeValue}
          />
          <Input
            label='recruiting.interview_schedules.edit.Event Buffer'
            tooltip={{paragraphs: [t('recruiting.interview_schedules.edit.tooltips.event_buffer')]}}
            value={eventBuffer}
            onChange={e => interviewSchedule.merge({eventBuffer: e.target.value})}
            connectedRight={
              <div className='InputGroup'>
                <span className='InputGroup-tag small'>{t('recruiting.interview_schedules.edit.minutes')}</span>
              </div>
            }
            errorMessage={errors.eventBuffer}
          />
        </FormLayout.Group>
        <AvailabilityWindowsTable
          windows={interviewSchedule.availabilityWindows}
          onChange={windows => interviewSchedule.merge({availabilityWindows: windows})}
          errorMessage={errors.availabilityWindows || _.get(errors, 'availabilityWindows.startTimeString') || _.get(errors, 'availabilityWindows.endTimeString')}
        />
        <Select2
          searchable
          label='recruiting.interview_schedules.edit.Time Zone'
          value={timezone}
          onChange={e => interviewSchedule.merge({timezone: e.target.value})}
          errorMessage={errors.timezone}
        >
          {timeZoneOptions.map(option => (
            <option key={option.value} value={option.value}>{option.label}</option>
          ))}
        </Select2>
      </FormLayout>
    </div>
  );
});

export default Availability;
